var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.749.1a.558.558 0 0 1 .241.57l-2.29 13.714a.562.562 0 0 1 -.286.4.547.547 0 0 1 -.277.072.6.6 0 0 1 -.214-.044l-4.04-1.651-2.161 2.634a.526.526 0 0 1 -.437.205.485.485 0 0 1 -.2-.036.571.571 0 0 1 -.375-.536v-3.116l7.714-9.456-9.541 8.26-3.527-1.446a.565.565 0 0 1 -.071-1.018l14.856-8.572a.545.545 0 0 1 .286-.08.553.553 0 0 1 .321.1z",
    fill: "#fff",
    transform: "translate(.002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.62b4f22aeab44f4f48b065c3f766f98c.svg";
export { ForwardRef as ReactComponent };